import { FC } from "react";
import { styled } from "styled-components";
import POSTER from "../assets/foto/dotace.png";
import { Container, PreText } from "../containers/PageContainer";
import { useMenu } from "../hooks/useMenu";
import { useScroll } from "../hooks/useScroll";
import { StyledH1 } from "../StyledComponents";

const Subsidy: FC = () => {
  const { isScrolled } = useScroll();
  const { isMenuClosed } = useMenu();

  return (
    <Container $isScrolled={isScrolled} $isMenuClosed={isMenuClosed}>
      <StyledH1>Dotace</StyledH1>
      <PreText>
        <p>
          Název projektu: <strong>FVE Karel Frajvald - Moravská třebová</strong>
        </p>
        <p>
          Číslo projektu: <strong>CZ.31.3.0/0.0/0.0/22_001/0003664</strong>
        </p>
        <p>
          <strong>Projekt je spolufinancován Evropskou unií.</strong>
        </p>
        <p>
          Cílem projektu je instalace fotovoltaické elektrárny sloužící
          pro&nbsp;vlastní spotřebu žadatele. Součástí projektu je pořízení
          bateriového úložiště.
        </p>
        <p>
          Cílem projektu je snížit spotřebu elektrické energie dodávané
          ze&nbsp;sítě z&nbsp;tradičních zdrojů díky využití energie
          z&nbsp;obnovitelného zdroje, čímž dojde ke&nbsp;snížení dopadu
          podnikatelské činnosti na&nbsp;životní prostředí v&nbsp;podobě snížení
          produkce emisí CO2 při výrobě el.&nbsp;energie.
        </p>
      </PreText>
      <Image src={POSTER} alt="Dotace" />
    </Container>
  );
};

const Image = styled.img`
  width: 60%;
  height: auto;
  margin: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default Subsidy;
